<template>
  <Transition
    enter-active-class="duration-200 ease-out"
    enter-from-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="duration-100 ease-in"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
  >
    <div
      v-if="props.showMenu"
      class="m-4 absolute inset-x-0 top-0 origin-top-right transform p-2 transition md:hidden border rounded border-turquoise"
    >
      <div
        class="rounded-lg bg-darkGunmetal shadow-lg ring-1 ring-black ring-opacity-5"
      >
        <div class="px-5 pt-5 pb-6">
          <div class="flex items-center justify-between">
            <a
              href="#"
              class="font-source-code font-extrabold text-xl"
              aria-label="Back to top"
              @click.prevent
            >
              <span class="text-turquoise">&lt;</span
              ><span class="text-paleBlue">jg</span
              ><span class="text-turquoise"> /&gt;</span>
            </a>
            <div class="-mr-2">
              <button
                @click="emits('close')"
                type="button"
                class="inline-flex items-center justify-center rounded-md bg-darkGunmetal p-2 font-outfit font-normal text-base text-paleBlue hover:text-waterSpout focus:outline-none focus:ring-2 focus:ring-inset focus:ring-turquoise"
              >
                <span class="sr-only">Close menu</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div class="mt-6">
            <nav class="grid gap-y-8">
              <a
                v-for="link in links"
                :key="link.href"
                :href="link.href"
                @click.prevent="goTo(link.href)"
                class="font-outfit text-base text-paleBlue hover:text-turquoise"
              >
                {{ link.label }}
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { scrollToSection } from "@/utils/smoothScroll";

// eslint-disable-next-line no-undef
const emits = defineEmits(["close"]);

// eslint-disable-next-line no-undef
const props = defineProps({
  showMenu: {
    default: false,
    type: Boolean,
  },
});

const links = [
  { href: "#about", label: "About me" },
  { href: "#experience", label: "Experience" },
  { href: "#contact", label: "Get in touch" },
];

function goTo(href) {
  emits("close");
  scrollToSection(href);
}
</script>
